import { BaseCaller } from './api';


export default class CategoryAPI {

    private caller: BaseCaller;

    constructor(caller: BaseCaller) {
        this.caller = caller;
    }

    public list(companyId: number): Promise<any> {
        return this.caller.get(`company/${companyId}/categories/`);
    };

    public listAvailable(companyId: number): Promise<any> {
        return this.caller.get(`company/${companyId}/categories/`);
    };

    save(companyId: number, data: any) {
        if (data.category.id) {
            console.log('put', data);
            return this.caller.put(`company/${companyId}/category/${data.category.id}`, data.category);
        }
        console.log('post', data);
        return this.caller.post(`company/${companyId}/categories/`, data.category);

    }

    disable(companyId: number, categoryId: number) {
        return this.caller.post(`company/${companyId}/category/${categoryId}/inactivate`, {});
    }

    addPhoto(companyId: number, categoryId: number, file: any) {
        return this.caller.postFormFile(`company/${companyId}/category/${categoryId}/photo`, file)
    }

    move(companyId: number, categoryId: number, direction: string) {
        return this.caller.post(`company/${companyId}/category/${categoryId}/move/${direction}`, {})
    }


}




// WEBPACK FOOTER //
// ./src/api/category-api.ts